"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.wrapChildren = void 0;
var react_1 = __importDefault(require("react"));
var react_is_1 = require("react-is");
var wrapWithComponent_1 = require("./wrapWithComponent");
/*
 * Wraps each element‘s child into Wrapper component, if it’s not
 * an instance of Wrapper. Returns wrapped children as an array.
 */
var wrapChildren = function (element, Component, props) {
    var childArray = react_is_1.isFragment(element) ? element.props.children : element;
    var childrens = react_1.default.Children.map(childArray, function (child) {
        if (child == null)
            return;
        return wrapWithComponent_1.wrapWithComponent(child, Component, props);
    });
    return childrens;
};
exports.wrapChildren = wrapChildren;
//# sourceMappingURL=wrapChildren.js.map